import { Divider } from "@material-ui/core";
import React, { useEffect, useState } from "react";

export const GoalHistoryTable = ({ payload, DBObject, uuid, t, title }) => {
  const [open, setOpen] = useState(false);

  const sorted = (set) => {
    var sortedSet = set.filter((i) => Object.keys(i).length > 1);
    sortedSet.sort((a, b) => {
      return a.occurrenceNumber < b.occurrenceNumber ? 1 : -1;
    });

    sortedSet.unshift(set[0]);
    return sortedSet;
  };
  const formatColumnHeadings = () => {
    return (
      <>
        {DBObject.indexTableHeaders.map((header) => {
          return (
            <th
              key={uuid()}
              className="patient-goal-table-heading-cell"
              style={{
                width: `${
                  header.id == 0 ? "50px" : header.id == 1 ? "270px" : "none"
                }`,
              }}
            >
              <span>{t(`views.goals.table.headings.${header.name}`)}</span>
            </th>
          );
        })}
        <th style={{ width: "33%" }}></th>
      </>
    );
  };

  const noGoals = (goalVersion) => {
    return goalVersion.length == 1
      ? t("views.goals.errors.no_goal_histories_for_goal")
      : "";
  };

  const buildTable = (historySet) => {
    if (!historySet) return;
    return historySet.map((goalVersion) => {
      return goalVersion.map((rowElement) => {
        if (!!rowElement.name) {
          return (
            <tr key={uuid()} className="goal-history-table-data-row-goal-name">
              <td colSpan={6} style={{ textAlign: "right" }}>
                <div className="goal-history-name">
                  <div>{noGoals(goalVersion)}</div>
                  <div>
                    {t("views.goals.headings.goal_name")}:{" "}
                    <span style={{ fontWeight: "normal", fontStyle: "italic" }}>
                      "{rowElement.name}"
                    </span>
                  </div>
                </div>
              </td>
            </tr>
          );
        } else {
          return (
            <tr
              style={{
                backgroundColor: rowElement.isActive ? "#FEEDCD" : "",
              }}
              className={`goal-history-table-data-row `}
              key={uuid()}
            >
              <td className="goal-history-table-data-cell color-indicator">
                <div
                  className={`goal-history-block-indicator indicate-${rowElement.completionColor}`}
                ></div>
              </td>
              <td className="goal-history-table-data-cell">
                {rowElement.timeFrame}
              </td>
              <td className="goal-history-table-data-cell">
                {rowElement.achievementStatusFormatted}
              </td>
              <td className="goal-history-table-data-cell">
                {rowElement.completionPercentage}
              </td>
              <td className="goal-history-table-data-cell">
                {rowElement.goal.achievementThresholdFormatted}
              </td>
              <td className="goal-history-table-overflow"></td>
            </tr>
          );
        }
      });
    });
  };

  const historyTable = () => {
    return (
      <div style={{ paddingLeft: "15px", paddingRight: "15px" }}>
        <table className="goal-history-table">
          <thead>
            <tr className="patient-goal-table-heading-row">
              {formatColumnHeadings()}
            </tr>
          </thead>
          <tbody>{buildTable(payload)}</tbody>
        </table>
      </div>
    );
  };

  return (
    <div className="goal-history-block" key={uuid()}>
      <div className="goal-history-block-title-bar">
        <div
          className="goal-history-block-dropdown"
          onClick={() => {
            setOpen(!open);
          }}
        >
          {open ? (
            <i className="icon-up-chevron"></i>
          ) : (
            <i className="icon-down-chevron"></i>
          )}
        </div>
        <div
          className="goal-history-block-title"
          onClick={() => {
            setOpen(!open);
          }}
        >
          {title}
        </div>
      </div>
      {open && historyTable()}
    </div>
  );
};
